import BasePage from "@/presentation/BasePage";
import { Component, Inject } from "vue-property-decorator";
import Vue2Filters from "vue2-filters";
import AlertMixin from "@/shared/alert/alert.mixin";
import { mixins } from "vue-class-component";
import HeaderService from "./header.service";

// Bắt sự kiện trước khi tab được đóng
window.addEventListener("beforeunload", function (e) {
  // Kiểm tra xem người dùng đã đăng nhập hay chưa
  var user = localStorage.getItem("user");

  if (user) {
    // debugger;
    // Nếu người dùng đã đăng nhập, xóa dữ liệu từ localStorage
    // localStorage.removeItem("user");
  }
});

// Bắt sự kiện khi trình duyệt đóng
window.addEventListener("unload", function (e) {
  // Kiểm tra xem người dùng đã đăng nhập hay chưa
  var user = localStorage.getItem("user");
  if (user) {
    // debugger;
    // Nếu người dùng đã đăng nhập, xóa dữ liệu từ localStorage
    // localStorage.removeItem("user");
  }
});

@Component({
  mixins: [Vue2Filters.mixin],
})
export default class HeaderContainer extends mixins(AlertMixin) {
  @Inject("headerService") private headerService: () => HeaderService;

  private full_name: string = "";
  private personalUser: any = "";
  HeaderService;
  public created() {
    const user = JSON.parse(localStorage.getItem("user"));
    this.getUserByUsers(user.username);
  }

  public getUserByUsers(username) {
    let query: any = {
      username: [],
    };
    query.username = [username];
    this.headerService()
      .getPersonalInfo(query)
      .then(
        (res) => {
          this.full_name = res[0].full_name;
          this.personalUser = res[0].username;
        },
        (erro) => {}
      );
  }

  public hanlderPushPresonInFor() {
    this.$router.push("/personal-info");
    // let loc = window.location;
    // loc.href = window.location.origin + "/personal-info";
  }

  public logOut() {
    this.headerService()
      .revoke()
      .then(
        (res) => {
          localStorage.removeItem("user");
          localStorage.removeItem("token");
          let loc = window.location;
          loc.href = window.location.origin + "/Login";
        },
        (erro) => {}
      );
    
  }
}
